import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default class ReportsTable extends Component {
  static propTypes = {
    datasetId: PropTypes.number,
    getReportDownloadLink: PropTypes.func.isRequired,
    selectedVersion: PropTypes.number,
    versionReports: PropTypes.object.isRequired,
  };

  static defaultProps = {
    datasetId: null,
    selectedVersion: null,
  };

  renderNoReports = () => (
    <div className="no-reports version text-muted">
      <p>There are no reports for the selected version</p>
    </div>
  );

  renderReportInfoSet = report => (
    <tr key={report.reportName} className="hoverable">
      <td>{report.reportName}</td>
      <td>{report.reportType}</td>
      <td>{this.renderViewReportButton(report)}</td>
      <td>{this.renderReportLinkButton(report)}</td>
    </tr>
  );

  renderReportLinkButton = report => {
    const { getReportDownloadLink } = this.props;
    return (
      <button
        title={report.reportName}
        className="btn btn-primary btn-sm btn-block"
        onClick={() => {
          getReportDownloadLink(report.reportName);
        }}
      >
        <small>Download</small>
      </button>
    );
  };

  renderViewReportButton = report => {
    const { datasetId, selectedVersion } = this.props;
    const { reportName, reportType } = report;
    return (
      <Link
        title={reportName}
        to={`/reports/report/${datasetId}/${selectedVersion}/${reportName}/${reportType}`}
        className="center-block"
      >
        <button className="btn btn-primary btn-sm btn-block">
          <small>View</small>
        </button>
      </Link>
    );
  };

  render() {
    const { versionReports } = this.props;
    const { reportInfoSet } = versionReports;

    return reportInfoSet.length > 0 ? (
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Details</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>{reportInfoSet.map(this.renderReportInfoSet)}</tbody>
      </table>
    ) : (
      this.renderNoReports()
    );
  }
}
